import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';

@Injectable({
  providedIn: 'root',
})
export class SefazAlertService {
  private readonly notifier: NotifierService;

  constructor(notifierService: NotifierService) {
    this.notifier = notifierService;
  }

  error(error: any): any {
    const ERRO = error.error ? error.error : error;
    if (ERRO.fieldErrors) {
      return ERRO.fieldErrors.forEach((item: any) => {
        this.notifier.notify('error', item.message);
      });
    }
    if (ERRO.message === undefined) {
      this.notifier.notify('error', ERRO);
    } else {
      this.notifier.notify('error', ERRO.detail ? ERRO.detail : ERRO.message);
    }
  }

  warning(warning: any): any {
    const WARNING = warning.error ? warning.error : warning;
    if (WARNING.fieldErrors) {
      return WARNING.fieldErrors.forEach((item: any) => {
        this.notifier.notify('warning', item.message);
      });
    }
    if (WARNING.message === undefined) {
      this.notifier.notify('warning', WARNING);
    } else {
      this.notifier.notify('warning', WARNING.detail ? WARNING.detail : WARNING.message);
    }
  }

  success(message: any): void {
    this.notifier.notify('success', message);
  }
}
